import { getServiceConfig } from "@/config/serviceConfig";
import api from "@/lib/axios";
import { Configuration } from "@/lib/api/generated/casedb";
import type { AxiosInstance } from "axios";

/** Generated operations share our authenticated axios and omit the forbidden User-Agent header. */
export async function catalogApiClient<T>(
  Client: new (configuration: Configuration, basePath: string, axios: AxiosInstance) => T,
): Promise<T> {
  const { caseDb } = await getServiceConfig();
  if (!caseDb) throw new Error("case-db service URL is not configured");
  return new Client(new Configuration({ baseOptions: { headers: {} } }), caseDb, api);
}
